module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "sai-item",
    style: ('background:linear-gradient(226deg, ' + _vm.colorRow.color + ' 0%, ' + _vm.colorRow.color2 + ' 100%)')
  }, [_c('div', {
    staticClass: "sai-item-top"
  }, [(_vm.row.is_online == 1) ? _c('div', {
    staticClass: "sai-item-type"
  }, [_vm._v("线上赛事")]) : _c('div', {
    staticClass: "sai-item-type"
  }, [_vm._v("线下赛事")]), _vm._v(" "), _c('div', {
    staticClass: "sai-item-bolid"
  }), _vm._v(" "), _c('div', {
    staticClass: "sa-item-time-range"
  }, [_vm._v(_vm._s(_vm.row.saidate_str) + "~" + _vm._s(_vm.row.saidate_end_str))])]), _vm._v(" "), _c('div', {
    staticClass: "sai-item-main"
  }, [_c('div', {
    staticClass: "sai-item-city",
    style: ('color:' + _vm.colorRow.city)
  }, [_vm._v(_vm._s(_vm.row.city))]), _vm._v(" "), _c('div', {
    staticClass: "sai-item-title show-two-row",
    style: ('color:' + _vm.colorRow.title)
  }, [_vm._v(_vm._s(_vm.row.name))]), _vm._v(" "), _c('div', {
    staticClass: "sai-item-btn"
  }, [(_vm.row.status != 1) ? _c('div', {
    staticClass: "sai-btn-left",
    style: ('color:' + _vm.colorRow.btn + ';border-color:' + _vm.colorRow.btn),
    on: {
      "click": function($event) {
        return _vm.onToWebView()
      }
    }
  }, [_vm._v("进入")]) : _vm._e(), _vm._v(" "), (_vm.row.status < 3) ? _c('div', {
    staticClass: "sai-btn-right",
    style: ('background:' + _vm.colorRow.btn),
    on: {
      "click": function($event) {
        return _vm.onToWebView2()
      }
    }
  }, [_vm._v("报名")]) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3995ad5b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/index/SaiItem.vue
// module id = 2329
// module chunks = 0